{{#if !@shared.isServer && !@shared.googleMapsLoaded}}
	<script>
		function onDocumentReady (fn) {
			if (document.readyState !== 'loading') {
				fn();
			} else {
				document.addEventListener('DOMContentLoaded', fn);
			}
		}
		/* eslint-disable */
		function initMap () {
			onDocumentReady(function () {
				app.loaded = true;

				if (app.initMap && app.router.route.view) {
					app.initMap();
				}
			});
		}
	</script>
	<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBTICLY5LgWNJ0Uly61Q1sNXz_1KZIECwg&amp;language=en&amp;callback=initMap&libraries=marker&loading=async" async></script>
	{{#if hasCluster}}
		<script src="https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.5.3/dist/index.umd.min.js"></script>
	{{/if}}
{{/if}}
<div id="gp-map" class="{{class}}"></div>

<script>
	/* global markerClusterer */
	const _ = require('../../assets/js/_');
	const MAP_MIN_ZOOM = 2;
	const MAP_MAX_ZOOM = 22;
	const MAP_ZOOM_REG = 3.74;
	const MAP_ZOOM_ALT = 2.14;
	const MAP_CENTER_REG = { lat: 48, lng: 16 };
	const MAP_CENTER_ALT = { lat: 30, lng: 18 };

	const getMarkerSize = (probeCount, zoom) => {
		let size = {
			svgWidth: 16,
			svgHeight: 16,
			circleRadius: 4.5,
			strokeWidth: 1.5,
		};

		if (probeCount > 1) {
			let scalingFactor = probeCount.toString().length;
			size.svgWidth += 4 * scalingFactor + 4;
			size.svgHeight += 4 * scalingFactor + 4;
			size.circleRadius += 2 * scalingFactor + 1.5;
			size.strokeWidth += .5;
		}

		if (zoom >= 5) {
			size.svgWidth *= 1.1;
			size.svgHeight *= 1.1;
		}

		if (zoom >= 10) {
			size.svgWidth *= 1.1;
			size.svgHeight *= 1.1;
		}

		return size;
	};

	let map;
	let infoWindows = [];
	let mapMarkers = [];
	let markerCluster;

	component.exports = {
		data () {
			return {
				class: '',
				iwClass: '',
				hasCluster: false,
				probesByCoords: null,
				onProbesByCoordsChange: null,
				onMarkerClick: null,
				selectedLocation: null,
				displayInfoWindow: true,
				lockMapBoundaries: false,
				mapMinZoom: MAP_MIN_ZOOM,
			};
		},
		onrender () {
			if (!Ractive.isServer) {
				this.set('@shared.googleMapsLoaded', true);
				app.initMap = this.initMap.bind(this);

				if (app.loaded) {
					setTimeout(this.initMap.bind(this));
				}
			}
		},
		onunrender () {
			if (!Ractive.isServer) {
				map = null;
				markerCluster = null;
				infoWindows = [];
				mapMarkers = [];
			}
		},
		initMap () {
			let mq = window.matchMedia('(min-width: 768px)');
			let lockMapBoundaries = this.get('lockMapBoundaries');

			map = new google.maps.Map(this.find('#gp-map'), {
				zoom: MAP_ZOOM_REG,
				center: MAP_CENTER_REG,
				mapTypeId: 'roadmap',
				draggableCursor: 'default',
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				minZoom: this.get('mapMinZoom'),
				maxZoom: MAP_MAX_ZOOM,
				mapId: 'ce04bbf9d49b6f34',
				...lockMapBoundaries && {
					restriction: {
						latLngBounds: new google.maps.LatLngBounds(
							{ lat: -85, lng: -179.5 },
							{ lat: 85, lng: 179.5 },
						),
						strictBounds: false,
					},
				},
			});

			if (mq.matches) {
				map.setCenter(MAP_CENTER_ALT);
				map.setZoom(MAP_ZOOM_ALT);
			}

			map.addListener('zoom_changed', () => {
				markerCluster?.clusters.forEach((c) => {
					let m = c.marker;
					let { svgWidth, svgHeight } = getMarkerSize(Number(m.content.getAttribute('data-probe-count')), map.zoom);
					m.content.style.width = `${svgWidth}px`;
					m.content.style.height = `${svgHeight}px`;
				});

				mapMarkers.forEach((m) => {
					let { svgWidth, svgHeight } = getMarkerSize(Number(m.content.getAttribute('data-probe-count')), map.zoom);
					m.content.style.width = `${svgWidth}px`;
					m.content.style.height = `${svgHeight}px`;
					m.content.setAttribute('data-zoom', map.zoom);
				});

				infoWindows.forEach(iw => iw.close());
			});

			this.observe('selectedLocation', (selectedLocation, prevSelectedLocation) => {
				// find markers whose coordinates are contained in the (previously) selected location
				let markersToHighlight = mapMarkers
					.filter(mm => selectedLocation.coords.some(c => c.latitude === mm.position.lat && c.longitude === mm.position.lng));

				let markersToFade = mapMarkers
					.filter(mm => !markersToHighlight.includes(mm)
					&& prevSelectedLocation.coords.some(c => c.latitude === mm.position.lat && c.longitude === mm.position.lng));

				// update marker bg colors
				markersToFade.forEach((markerToFade) => {
					let svgUnselected = this.createClusterMarkerSVG(markerToFade.markersCount || 0, false);
					markerToFade.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgUnselected}')`;
				});

				markersToHighlight.forEach((markerToHighlight) => {
					let svgSelected = this.createClusterMarkerSVG(markerToHighlight.markersCount || 0, true);
					markerToHighlight.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgSelected}')`;
				});

				// update cluster marker bg colors
				markerCluster?.clusters.forEach((cluster) => {
					if (cluster.markers.length <= 1) {
						return;
					}

					let totalProbeCount = cluster.markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);

					if (markersToHighlight.some(markerToHighlight => cluster.markers.includes(markerToHighlight))) {
						let svgHighlighted = this.createClusterMarkerSVG(totalProbeCount, true);
						cluster.marker.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgHighlighted}')`;
					} else if (markersToFade.some(markerToFade => cluster.markers.includes(markerToFade))) {
						let svgUnselected = this.createClusterMarkerSVG(totalProbeCount, false);
						cluster.marker.content.style.backgroundImage = `url('data:image/svg+xml;base64,${svgUnselected}')`;
					}
				});

				if (!selectedLocation) {
					return;
				}

				// make sure the selected location is visible
				let bounds = map.getBounds();
				let probesByCoords = this.get('probesByCoords');
				let position = { lat: selectedLocation.coords[0].latitude, lng: selectedLocation.coords[0].longitude };

				if (!bounds?.contains(position)) {
					this.focusMapOnMarkers(probesByCoords);
				}
			});

			this.observe('probesByCoords', (markersData, prevMarkersData) => {
				if (markersData && JSON.stringify(markersData) !== JSON.stringify(prevMarkersData)) {
					// hide all existing markers from the map
					mapMarkers.forEach(mm => mm.map = null);

					// show the marker or create one if it is missing
					let filteredMarkers = Object.keys(markersData).map((key) => {
						let [ lat, lng ] = key.split(', ');
						let marker = mapMarkers.find(mm => mm.position.lat === lat && mm.position.lng === lng);

						if (!marker) {
							marker = this.createMapMarkerWithIW(key, markersData[key]);
							mapMarkers.push(marker);
						}

						marker.map = map;

						return marker;
					});

					let createClusterMarkerSVG = this.createClusterMarkerSVG;
					let getSelectedLocation = () => this.get('selectedLocation');

					if (markerCluster) {
						markerCluster.clearMarkers();
						markerCluster.addMarkers(filteredMarkers);
					} else if (this.get('hasCluster')) {
						markerCluster = new markerClusterer.MarkerClusterer({
							map,
							markers: filteredMarkers,
							renderer: {
								render ({ markers, position }) {
									let totalCustomNumber = markers.reduce((sum, marker) => sum + (marker.markersCount || 0), 0);
									let selectedLocation = getSelectedLocation();
									let shouldHighlight = !selectedLocation
										|| markers.some(m => selectedLocation.coords.some(pos => m.position.lat === pos.latitude && m.position.lng === pos.longitude));
									let svg = createClusterMarkerSVG(totalCustomNumber, shouldHighlight);

									let clusterDiv = document.createElement('div');
									clusterDiv.setAttribute('data-probe-count', totalCustomNumber);
									clusterDiv.setAttribute('data-zoom', map.zoom);

									clusterDiv.style.position = 'relative';
									clusterDiv.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
									clusterDiv.style.backgroundRepeat = 'no-repeat';
									clusterDiv.style.backgroundPosition = 'center';
									clusterDiv.style.backgroundSize = 'contain';

									let { svgWidth, svgHeight } = getMarkerSize(totalCustomNumber, map.zoom);
									clusterDiv.style.width = `${svgWidth}px`;
									clusterDiv.style.height = `${svgHeight}px`;

									return new google.maps.marker.AdvancedMarkerElement({
										position,
										content: clusterDiv,
										zIndex: totalCustomNumber,
									});
								},
							},
							algorithm: new markerClusterer.SuperClusterAlgorithm({
								radius: 40,
							}),
							onClusterClick: (e, cluster, map) => {
								// temporarily remove restriction to allow proper fit
								let prevRestriction = map.get('restriction');
								map.setOptions({ restriction: undefined });

								// default handler
								markerClusterer.defaultOnClusterClickHandler(e, cluster, map);

								// restore restriction after the map settles
								google.maps.event.addListenerOnce(map, 'idle', () => {
									map.setOptions({
										restriction: prevRestriction,
									});
								});
							},

						});
					}

					if ((this.get('onProbesByCoordsChange') && this.get('onProbesByCoordsChange')()) || this.get('focusOnChange')) {
						this.focusMapOnMarkers(markersData);
					} else {
						if (!mq.matches) {
							map.setCenter(MAP_CENTER_REG);
							map.setZoom(MAP_ZOOM_REG);
						} else {
							map.setCenter(MAP_CENTER_ALT);
							map.setZoom(MAP_ZOOM_ALT);
						}
					}
				}
			});


			// close IWs on click on Map
			google.maps.event.addListener(map, 'click', () => {
				infoWindows.forEach(iw => iw.close());
			});
		},
		createMapMarkerWithIW (key, markerData) {
			let [ lat, lng ] = key.split(', ');
			let onMarkerClick = this.get('onMarkerClick');
			let selectedLocation = this.get('selectedLocation');
			let shouldHighlight = !selectedLocation
				|| selectedLocation.coords.some(pos => pos.latitude === Number(lat) && pos.longitude === Number(lng));

			let svg = this.createMapMarkerSvg(markerData, shouldHighlight);

			let markerContent = document.createElement('div');
			markerContent.style.backgroundImage = `url('data:image/svg+xml;base64,${svg}')`;
			markerContent.style.backgroundRepeat = 'no-repeat';
			markerContent.style.backgroundPosition = 'center';
			markerContent.style.backgroundSize = 'contain';
			markerContent.setAttribute('data-probe-count', markerData.length);

			let { svgWidth, svgHeight } = getMarkerSize(markerData.length, map.zoom);
			markerContent.style.width = `${svgWidth}px`;
			markerContent.style.height = `${svgHeight}px`;

			// Create a new AdvancedMarkerView
			let marker = new google.maps.marker.AdvancedMarkerElement({
				map,
				content: markerContent,
				position: { lat: Number(lat), lng: Number(lng) },
				zIndex: 1,
			});

			marker.markersCount = markerData.length || 0;

			// Handle closing of all InfoWindows on a click on a marker
			marker.addListener('click', () => {
				onMarkerClick && onMarkerClick({ latitude: Number(lat), longitude: Number(lng) });
			});

			if (this.get('displayInfoWindow')) {
				let infoWindow = new google.maps.InfoWindow();
				infoWindows.push(infoWindow);
				infoWindow.setContent(this.createInfoWindowContent(markerData));

				marker.addListener('click', () => {
					infoWindows.forEach(iw => iw.close());
					infoWindow.open({ map, anchor: marker });
				});
			}

			return marker;
		},
		createMapMarkerSvg (markerData, shouldHighlight = true) {
			return this.createClusterMarkerSVG(markerData.length, shouldHighlight);
		},
		createInfoWindowContent (markersByCoords) {
			let markersCnt = markersByCoords.length;
			let groupedNetworks = markersByCoords.reduce((res, m) => {
				let marker = res.find(i => i.location.network === m.location.network);

				if (marker) {
					marker.cnt += 1;
				} else {
					res.push({ ...m, cnt: 1, sortKey: m.location.network.toLowerCase() });
				}

				return res;
			}, []).sort((a, b) => a.sortKey < b.sortKey ? -1 : a.sortKey > b.sortKey);

			let infoWindowContent = `<div class="${this.get('iwClass')}">`;

			if (markersCnt === 1) {
				let { network, city, country } = markersByCoords[0].location;

				infoWindowContent += `<span>${network} (${city}, ${country})</span>`;
			} else {
				// in this case we should render a list of probes
				groupedNetworks.forEach((m, mIdx) => {
					if (mIdx === 0) {
						// add header content
						infoWindowContent += `<span class="${this.get('iwClass')}_header">`;
						infoWindowContent += `<img width="16" height="16" src="${this.get('@shared.assetsHost')}/img/location-icon.svg">`;
						infoWindowContent += `<span class="${this.get('iwClass')}_header_location">${m.location.city}, ${m.location.country}</span>`;
						infoWindowContent += `<span class="${this.get('iwClass')}_header_cnt">${markersByCoords.length}</span>`;
						infoWindowContent += '</span>';
					}

					// render the list of the probes, grouped by the same network
					infoWindowContent += `<span class="${this.get('iwClass')}_row">${m.location.network} ${m.cnt > 1 ? `<span class="${this.get('iwClass')}_row_network-cnt">${m.cnt}</span>` : ''}</span>`;
				});
			}

			infoWindowContent += '</div>';

			return infoWindowContent;
		},
		createClusterMarkerSVG (elementsCnt, shouldHighlight = true) {
			let { svgWidth, svgHeight, circleRadius, strokeWidth } = getMarkerSize(elementsCnt, 1); // here zoom must always be 1
			let backgroundColor = shouldHighlight ? '#17D4A7' : '#202020';

			return window.btoa(`
				<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g filter="url(#filter0_d_6106_3045)">
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius}" fill="${backgroundColor}"/>
						<circle cx="${svgWidth / 2}" cy="${svgHeight / 2}" r="${circleRadius + 1}" stroke="white" stroke-width="${strokeWidth}"/>
					</g>
					${elementsCnt !== 1 ? `<text x="${svgWidth / 2}" y="${svgHeight / 2}" text-anchor="middle" dy=".35em" font-family="Arial" font-size="10" font-weight="bold" fill="#fff">${elementsCnt}</text>` : ''}
					<defs>
						<filter id="filter0_d_6106_3045" x="0" y="0" width="${svgWidth}" height="${svgHeight}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix"/>
							<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
							<feOffset dy="1"/>
							<feGaussianBlur stdDeviation="1"/>
							<feComposite in2="hardAlpha" operator="out"/>
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6106_3045"/>
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6106_3045" result="shape"/>
						</filter>
					</defs>
				</svg>
			`);
		},
		focusMapOnMarkers (markersData) {
			let locationStrings = Object.keys(markersData);
			let selectedLocation = this.get('selectedLocation');
			let minZoom = this.get('mapMinZoom');

			if (locationStrings.length === 0) {
				return;
			}

			// first, create the map bounds
			let bounds = new google.maps.LatLngBounds();

			locationStrings.forEach((str) => {
				let [ lat, lng ] = str.split(', ');
				bounds.extend({ lat: Number(lat), lng: Number(lng) });
			});

			let shouldSnapToSelected = false;
			let mapDiv = map.getDiv();

			// if there is a selected location, check whether we can fit all markers on the map
			// if not, snap the map to the selected location with min zoom
			// otherwise we cannot guarantee that the selected location will be visible
			// https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames
			// https://en.wikipedia.org/wiki/Web_Mercator_projection
			if (selectedLocation && mapDiv && mapDiv.offsetWidth > 0) {
				let ne = bounds.getNorthEast();
				let sw = bounds.getSouthWest();

				// --- find lng span (in deg) ---
				let boundsSpanLng = ne.lng() - sw.lng();

				if (boundsSpanLng < 0) {
					boundsSpanLng += 360;
				}

				// calculate the visible longitude span at MinZoom (Zoom 2)
				// formula: (map width / tile size) * (360 degrees / 2^zoom)
				let degreesPerTile = 360 / Math.pow(2, minZoom);
				let visibleSpanLng = (mapDiv.offsetWidth / 256) * degreesPerTile;

				// --- find lat span (in px -- cannot rely on degrees because of projection distortion) ---
				let latToWorldY = (lat) => {
					let sin = Math.sin(lat * Math.PI / 180);
					// clip to prevent infinity at the poles
					sin = Math.max(Math.min(sin, 0.9999), -0.9999);
					let latPosRadians = 0.5 * Math.log((1 + sin) / (1 - sin)); // = log(tan(lat/2))
					let scaler = 256 / (2 * Math.PI);
					return 128 + 0.5 * latPosRadians * scaler;	// scale and center
				};

				let neY = latToWorldY(ne.lat());
				let swY = latToWorldY(sw.lat());

				// calculate height in pixels at the current minZoom
				let boundsHeightPx = Math.abs(neY - swY) * Math.pow(2, minZoom);
				let mapHeightPx = mapDiv.offsetHeight;

				// check overflow
				if (boundsSpanLng > visibleSpanLng || boundsHeightPx > mapHeightPx) {
					shouldSnapToSelected = true;
				}
			}

			if (shouldSnapToSelected) {
				let position = {
					lat: _.clamp(selectedLocation.coords[0].latitude, 15, 35),
					lng: selectedLocation.coords[0].longitude,
				};
				map.setCenter(position);
				map.setZoom(minZoom);
			} else {
				let TEMP_MAX_ZOOM = 6;

				// temp limit for zooming
				map.setZoom(TEMP_MAX_ZOOM);
				map.setOptions({ maxZoom: TEMP_MAX_ZOOM });
				map.fitBounds(bounds);

				google.maps.event.addListenerOnce(map, 'idle', () => {
					// restore zooming to initial
					map.setOptions({ maxZoom: MAP_MAX_ZOOM });
				});
			}
		},
	};
</script>
